// extracted by mini-css-extract-plugin
module.exports = {"Form":"Form_Form__1lAKg","Form__Head":"Form_Form__Head__1ZJYu","Icon":"Form_Icon__1Oi9F","Form__Form":"Form_Form__Form__39Zv2","Input":"Form_Input__3jTW-"};